var exports = {
  "kL": "container__wyff7Z",
  "VH": "anchorTop__IlYYaR",
  "$m": "anchorBottom__R8qX3M",
  "cG": "closeButtonContainer__q2Oz5W",
  "mz": "staffPillLink__ao5cqt",
  "mw": "messageRow__gsjbQ3",
  "zc": "iconContainer__ZS23HF",
  "BK": "messageContent__-RjLJj",
  "QI": "messageLabel__slo4h9",
  "Lo": "messageText__-7Qeh0",
  "Un": "errorContainer__91kHze",
  "g4": "loadingContainer__N5EEU8",
  "h5": "loadingLabel__YKOBM_",
  "KQ": "loadingText__yFBmSF",
  "uu": "actionButtons__heTV0m",
  "hP": "actionButton__L9u526",
  "Ox": "inputArea__Rs6fP5",
  "PC": "textarea__m2-mtM",
  "jo": "sendButton__30LT1b",
};

module.exports = exports;
